export const getOriginalPageProps = () =>
  JSON.parse(document.getElementById('__NEXT_DATA__')?.textContent ?? '').props.pageProps
